import { Observable, take } from 'rxjs';
import { map, switchMap, tap } from 'rxjs/operators';
import { Action } from '@ngrx/store';
import { TranslocoService } from '@jsverse/transloco';
import { Injectable } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';

import { fetchMessageAction } from '@app/store/actions/global.actions';
import { ToastrTypes } from '@app/entities/toastr';
import { AvoDispatchOrchestrator } from '@avo/orchestrator/avo.dispatch';
import { AvoService } from '@avo/services/avo.service';
import { AVO_EVENTS } from '@avo/events/avo.events';
import { getErrorMessage } from '@app/util/error-messages';
import { PropertiesAmplitudeService } from '@app/services/properties-amplitude.service';
import { SearchBy } from '@shared/base-search-bar/entities/search.entities';

@Injectable()
export class UpsellAbstractEffects {

  protected AvoDispatch = new AvoDispatchOrchestrator();

  constructor(
    protected translate: TranslocoService,
    protected avoService: AvoService,
    protected amplitudeService: PropertiesAmplitudeService,
  ) { }

  protected getUpsellOptionError$(
    e: HttpErrorResponse, searchBy: SearchBy, segment: string | undefined = undefined, flow: string | undefined = undefined
  ): Observable<Action> {
    return this.amplitudeService.searchProperties$(searchBy).pipe(
      take(1),
      switchMap(searchProps => this.avoService.getEventTriggerProps$(
        AVO_EVENTS.TRAVEL_UPSELL_OPTIONS_ERROR,
        { ERROR_MESSAGE: getErrorMessage(e) },
        searchProps
      ).pipe(
        take(1),
        tap(trigger => {
          this.AvoDispatch.travelUpsellOptionsError({
            ...this.avoService.avoBaseProperties(trigger),
            ...this.avoService.avoSearchProps(trigger?.SEARCH_PROPS),
            errorMessage: trigger?.EVENT_PROPS?.ERROR_MESSAGE as string,
            searchFlowType: segment ?? undefined,
            travelSegment: flow ?? undefined,
          });
        }),
        map(() => {
          return fetchMessageAction({
            toastr: {
              message: this.translate.translate('FLIGHT_RESULTS_MODULE.UPSELL.RATES_NOT_AVAILABLE'),
              type: ToastrTypes.WARNING
            }
          });
        })
      ))
    );
  }
}
